/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig, EntityUIStore } from '@datorama/akita';
import { EmergencyVehicle } from '../../model/emergency-vehicle';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface VehicleState extends EntityState<EmergencyVehicle> {
  ui: VehicleUI;
}
export interface VehicleUIState extends EntityState<VehicleUI> { }


// TODO: Mabye create an additional initial state?
export type VehicleUI = {
  isSelectedForFilter: boolean;
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'vehicle' })
export class VehicleStore extends EntityStore<VehicleState> {
  ui: EntityUIStore<VehicleUIState>;

  constructor() {
    super();
    this.createUIStore().setInitialEntityState({ isSelectedForFilter: false });
  }

  akitaPreUpdateEntity(_: EmergencyVehicle, newEntity: EmergencyVehicle) {
    const decodedEntity = decodeEntity(newEntity);
    return setLocation(decodedEntity);
  }

  akitaPreAddEntity(entity: EmergencyVehicle) {
    const decodedEntity = decodeEntity(entity);
    return setLocation(decodedEntity);
  }
}

function decodeEntity(entity: EmergencyVehicle) {
  const copy = { ...entity };

  copy.name = decodeFiwareString(entity.name);
  copy.description = decodeFiwareString(entity.description);
  copy.cameraConfig = decodeFiwareString(entity.cameraConfig);

  return copy;
}

function setLocation(entity: EmergencyVehicle) {
  if (!entity.location) {
    entity.location = {
      type: 'Point',
      coordinates: []
    };
  }
  return entity;
}
